import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import Util from "../../Util";
import { LoadModal } from "../modais";
import { TableLayout } from "../../components";
import * as ApiHelper from "../../ApiHelper";
import { ToastContainer, ToastMessage } from "react-toastr";
class TableContratos extends Component {
  constructor() {
    super();
    this.toastFactory = React.createFactory(ToastMessage.animation);
    this.delete = this.delete.bind(this);
    this.print = this.print.bind(this);
    this.state = {
      showLoad: false,
    };
  }
  addAlert(title, message) {
    this.container.error(title, message, {
      timeOut: 5000,
      extendedTimeOut: 3000,
    });
  }
  delete(id) {
    ApiHelper.deleteContratado(id, (error) => {
      if (error) {
        this.addAlert("", error.message);
      } else {
        this.props.onDelete();
      }
    });
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad,
    });
  }
  print(event) {
    this.toggleLoadModal();
    ApiHelper.getRelacaoContratados((file, error) => {
      this.toggleLoadModal();
      if (file) {
        var date = new Date();
        var dateString =
          (date.getDate() + "").padStart(2, "0") +
          "-" +
          (date.getMonth() + "").padStart(2, "0") +
          "-" +
          date.getFullYear();

        var url = URL.createObjectURL(file);
        var tempLink = document.createElement("a");
        tempLink.href = url;
        tempLink.setAttribute(
          "download",
          "Relação de contratados cadastrados-" + dateString + ".pdf"
        );
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
      } else {
        this.addAlert("", error.message);
      }
    });
  }
  render() {
    var buttons = [
      {
        title: "Criar contratado",
        link: "/contratados/create",
        icon: "control_point",
      },
      {
        title: "Contratados deletados",
        link: "/contratados/trash",
        icon: "delete",
      },
    ];
    var additionalButtons = [
      {
        title: "Imprimir todos os contratados",
        callBack: this.print,
        icon: "print",
      },
    ];
    var tableHeaders = [
      "CPF/CNPJ",
      "Nome/Razão social",
      "Telefone",
      "Endereço",
      "Ações",
    ];
    return (
      <div>
        <ToastContainer
          ref={(input) => {
            this.container = input;
          }}
          toastMessageFactory={this.toastFactory}
          className="toast-top-right"
          preventDuplicates={true}
        />
        <LoadModal onClose={this.toggleLoadModal} show={this.state.showLoad} />
        <TableLayout
          headerButtons={buttons}
          sizeClass={this.props.sizeClass}
          additionalButtons={additionalButtons}
          backgroundColor={this.props.backgroundColor}
          title={this.props.title}
          subtitle={this.props.subtitle}
          filter={this.props.filter}
          searchLabel="Pesquisar contratado"
        >
          <table className="table table-hover">
            <thead className="text-warning">
              <tr>
                {tableHeaders.map((header, key) => {
                  return <th key={key}>{header}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              {this.props.rows.map((row, key) => {
                return (
                  <tr key={key}>
                    <td className="col-md-2">
                      {Util.getMaskedCPFCNPJ(row.cpf_cnpj)}
                    </td>
                    <td className="col-sm-5">{row.nome_razao_social}</td>
                    <td className="col-sm-2">
                      {Util.getMaskedPhone(row.telefone)}
                    </td>
                    <td className="col-sm-4">
                      {row.rua +
                        ", " +
                        row.numero +
                        ", " +
                        row.bairro +
                        ", " +
                        row.cidade +
                        ", " +
                        row.estado}
                    </td>
                    <td className="td-actions text-right">
                      <Link
                        title="Editar contratado"
                        className="btn btn-primary btn-simple btn-xs"
                        to={"contratados/edit/" + row.id}
                      >
                        <i className="material-icons">edit</i>
                      </Link>
                      <button
                        type="button"
                        rel="tooltip"
                        title="Remover contratado"
                        onClick={() => this.delete(row.id)}
                        className="btn btn-danger btn-simple btn-xs"
                      >
                        <i className="material-icons">close</i>
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </TableLayout>
      </div>
    );
  }
}
export default withRouter(TableContratos);



// WEBPACK FOOTER //
// ./src/views/contratados/TableContratados.js